/*
 * Saidai ref / UTM passthrough (指示書 §5-2)
 *
 * Shopify Liquidはクエリ文字列を読めないため、クライアントJSで実装する。
 *
 * 1. ページ読み込み時に location.search から ref / utm_* を読み取り、
 *    あれば sessionStorage（キー: saidai_ref_params）に保存する。
 * 2. CTAリンク（a[href^="/pages/contact"], a[data-sd-cta]）に保存済みパラメータを
 *    クエリ文字列として付与する。既存クエリとマージし、ハードコードは上書きしない。
 * 3. お問い合わせページの hidden 入力 contact[ref] に値をセットする。
 *    ref 単体、なければ utm_source/utm_medium/utm_campaign を "|" 連結した文字列。
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'saidai_ref_params';
  var TRACKED = ['ref', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

  function readStore() {
    try {
      var raw = window.sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }

  function writeStore(params) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(params));
    } catch (e) {
      /* sessionStorage が使えない環境では黙って諦める */
    }
  }

  /* 1. URLから取得し、保存済みとマージ（新しい値を優先） */
  function capture() {
    var search = new URLSearchParams(window.location.search);
    var stored = readStore();
    var found = false;

    TRACKED.forEach(function (key) {
      var value = search.get(key);
      if (value) {
        stored[key] = value;
        found = true;
      }
    });

    if (found) writeStore(stored);
    return stored;
  }

  /* 2. CTAリンクにパラメータを付与（既存クエリは尊重し、上書きしない） */
  function decorateLinks(params) {
    var keys = Object.keys(params);
    if (!keys.length) return;

    var links = document.querySelectorAll('a[href^="/pages/contact"], a[data-sd-cta]');

    Array.prototype.forEach.call(links, function (link) {
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;

      var url;
      try {
        url = new URL(href, window.location.origin);
      } catch (e) {
        return;
      }

      /* 同一オリジンのみ対象 */
      if (url.origin !== window.location.origin) return;

      keys.forEach(function (key) {
        /* 既にリンク側で指定されている値はハードコードとして尊重する */
        if (!url.searchParams.has(key)) {
          url.searchParams.set(key, params[key]);
        }
      });

      link.setAttribute('href', url.pathname + url.search + url.hash);
    });
  }

  /* 3. contact[ref] の hidden 入力に値をセット */
  function fillRefField(params) {
    var field = document.querySelector('input[name="contact[ref]"]');
    if (!field) return;

    var value = params.ref;

    if (!value) {
      var parts = [params.utm_source, params.utm_medium, params.utm_campaign].filter(Boolean);
      if (parts.length) value = parts.join('|');
    }

    if (value) field.value = value;
  }

  function init() {
    var params = capture();
    decorateLinks(params);
    fillRefField(params);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
